// extracted by mini-css-extract-plugin
module.exports = {"root":"Images90_root__23DAV","title":"Images90_title__2z9mA","images":"Images90_images__2s9tI"};